import { tbColors } from 'styles/colors';

const getMuiContainer = () => ({
  styleOverrides: {
    root: {
      display: 'inline-flex' as const,
      flexDirection: 'column' as const,
      backgroundColor: tbColors.all.grey[50],
    },
  },
});

export default getMuiContainer;
